import React from "react";
import Chart from "react-apexcharts";

const RevenueAndExpensesView = () => {
  const chartOptions = {
    chart: {
      id: "column-chart",
      toolbar: {
        show: true,
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: [
      {
        title: {
          text: "Sales",
        },
      },
      {
        opposite: true,
        title: {
          text: "Collection",
        },
      },
    ],
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        endingShape: "rounded",
      },
    },
    colors: ["#008FFB", "#00E396"],
    tooltip: {
      enabled: true,
    },
  };

  const chartSeries = [
    {
      name: "Sales",
      data: [30, 20, 40, 60, 10, 40, 50, 66, 77, 12, 80, 56],
    },
    {
      name: "Revenue",
      data: [
        18000, 20000, 5000, 40000, 12000, 30000, 14000, 80000, 110000, 12000,
        600000, 165200,
      ],
    },
  ];

  return (
    <div>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default RevenueAndExpensesView;
